/**
 * @packageDocumentation
 * Renders the total-win button widget that expands to show cumulative payouts and links into the win popup timeline.
 */
import * as PIXI from "pixi.js"; 
import { Assets } from 'pixi.js'; 
import { font_main } from "./global";
/**
 * Class representing the totalWinting area UI component
 * @extends PIXI.Container
 */
export class TotalWinButton extends PIXI.Container{
    totalWinContainer: any;
    totalWinLabel: PIXI.Text;
    totalwinValueText: PIXI.Text;
    constructor(){
        super();
        this.totalWinContainer = new PIXI.Container();
        let totalWinBg =  new PIXI.Sprite(Assets.get("Total_win_but"));
        totalWinBg.anchor.set(0.5); 
        totalWinBg.scale.set(0.75);
        
        this.totalwinValueText = new PIXI.Text();
        this.totalwinValueText.style = {
            fontFamily: font_main, 
            align:"center",
            fill: 'white', 
            fontSize: 30,
            fontWeight: 'bold',
            stroke:{
                color:"black",
                width:4,
                join:"round"
            },
            letterSpacing:1
        };
        this.totalwinValueText.anchor.set(0.5);
        this.totalwinValueText.text = "$0.00"

        this.totalwinValueText.anchor.set(0.5)
        this.totalWinContainer.addChild(totalWinBg,this.totalwinValueText);
        this.totalWinContainer.x = 100;
        this.totalWinLabel = new PIXI.Text();
        this.totalWinLabel.text = "TOTAL WIN";
        this.totalWinLabel.style = {
            fontFamily: font_main, 
            align:"center",
            fill:"white",
            fontSize: 23,
            fontWeight: 'lighter',
            dropShadow: {
                alpha: 0.8,
                angle: 1,
                blur: 4,
                color: '0x111111',
                distance: 2,
            },
            stroke:{
                color:"black",
                width:4,
                join:"round"
            },
            letterSpacing:2
        };
        this.totalWinLabel.x = 34;
        this.totalWinLabel.y = -70+5;

        this.addChild(this.totalWinContainer); 
        this.addChild(this.totalWinLabel); 
    }
    // inside class TotalWinButton
        public setValue(amount: number|string) {
        this.totalwinValueText.text = `${amount}`;
        }
}